import * as imagesLoaded from 'imagesloaded';

export class SplitScreen {
    private container: JQuery;


    /**
     * Creates a new instance of SplitScreen
     *
     * @param container The containing element
     */
    constructor(container: HTMLElement) {
        this.container = $(container);

        this.addListeners();
    }


    /**
     * Add's the various event listeners for this block.
     *
     * @private
     * @memberof SplitScreen
     */
    protected addListeners(): void {

        // When the images have loaded, add a class to the container.
        imagesLoaded(this.container.get(0), () => {
            this.container.addClass('c-split-screen--has-loaded');
        });
    }
}
